import React from 'react'
import "./Caract__style.scss"

export default function General({ item, hatImage, cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage}) {

  const images = {
    pdv: require("./../../../Asset/Stuff/pct.19f83f93.png"),
    pa: require("./../../../Asset/Stuff/pa.png"),
    pm: require("./../../../Asset/Stuff/pm.90f0ffe6.png"),
    po: require("./../../../Asset/Stuff/po.png"),
    cc: require("./../../../Asset/Stuff/cc.png"),
    agi: require("./../../../Asset/Stuff/agi.png"),
    chance: require("./../../../Asset/Stuff/chance.png"),
    force: require("./../../../Asset/Stuff/force.png"),
    intel: require("./../../../Asset/Stuff/intel.png"),
    sasa: require("./../../../Asset/Stuff/saas.png"),
    ini: require("./../../../Asset/Stuff/ini.png"),
    invo: require("./../../../Asset/Stuff/invo.png"),
    pui: require("./../../../Asset/Stuff/pui.png"),
    soin: require("./../../../Asset/Stuff/soin.png"),
    prospe: require("./../../../Asset/Stuff/prospe.png"),
  }

  const baseInfo = {
    pdv:1050,
    pa: 7,
    pm: 3,
    pp: 100,
    invocation: 1
  };

  const getTotalCaractValue = (items, type) => {
    return items.reduce((total, item) => {
      if (item && Array.isArray(item.effects)) {
        const effect = item.effects.find((effect) => effect.type.name === type);
        if (effect) {
          return total + (effect.int_maximum || 0);
        }
      }
      return total;
    }, 0);
  };
  const getTotalCaractValueMin = (items, type) => {
    return items.reduce((total, item) => {
      if (item && Array.isArray(item.effects)) {
        const effect = item.effects.find((effect) => effect.type.name === type);
        if (effect) {
          return total + (effect.int_minimum || 0);
        }
      }
      return total;
    }, 0);
  };

  return (
    <div className="stats__style">
      <div className="stats__wrapper">
        <div className="stats pv">
          <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Vitalité') > 0 ? "left__number" : "left__number0"}>{baseInfo.pdv + getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Vitalité')} </div><span><img src={images.pdv} alt="" /></span> Pdv
        </div>
        <div className="stats pa">
          <div className={getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'PA') > 0 ? "left__number" : "left__number0"}>{baseInfo.pa + getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'PA')} </div><span><img src={images.pa} alt="" /></span> PA
        </div>
        <div className="stats pm">
        <div className={getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'PM') > 0 ? "left__number" : "left__number0"}>{baseInfo.pm + getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'PM')}  </div><span><img src={images.pm} alt="" /></span> PM
        </div>
        <div className="stats prospe">
          <div className={getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Prospection') > 0 ? "left__number" : "left__number0"}>{baseInfo.pp + getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Prospection')} </div><span><img src={images.prospe} alt="" /></span> PP
        </div>
        <div className="stats po">
        <div className={getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Portée') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Portée')} </div><span><img src={images.po} alt="" /></span> PO
        </div>
      </div>
      <div className="stats__wrapper">
        <div className="stats ini">
          <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Initiative') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Initiative')} </div><span><img src={images.ini} alt="" /></span> Ini
        </div>
        <div className="stats cri">
          <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], '% Critique') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], '% Critique')} </div><span><img src={images.cc} alt="" /></span> Crit
        </div>
        <div className="stats invo">
        <div className={getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Invocation') > 0 ? "left__number" : "left__number0"}>{baseInfo.invocation + getTotalCaractValueMin([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Invocation')} </div><span><img src={images.invo} alt="" /></span> Invo
        </div>
        <div className="stats soin">
          <div className={getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Soins') > 0 ? "left__number" : "left__number0"}>{getTotalCaractValue([item, hatImage,cloakImage, swordImage, anno2Image, beltImage, bootsImage, amuImage], 'Soins')}</div><span><img src={images.soin} alt="" /></span> Soin
        </div>
      </div>
    </div>
  )
}
